import { isAxiosError } from 'axios'
import { api } from '@/lib/api'
import type { PriceQuote } from '@/types/price'

/**
 * Liefert den aktuellen Kurs für eine ISIN. `null` bei 404
 * (keine Position / yfinance unavailable) — alles andere wirft.
 */
export async function getPrice(isin: string): Promise<PriceQuote | null> {
  try {
    const { data } = await api.get<PriceQuote>(`/prices/${isin}`)
    return data
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 404) return null
    throw err
  }
}
